import React, { useState } from 'react';

import dayjs from 'dayjs-ext';

import propTypes from 'prop-types';
import { Checkbox } from 'src/ui/mui-ui-kit';
import { UiTable, startsWithCaseInsensitive } from '../../ui';
import { DATE_SMONTH_DAY_SYEAR } from '../../ui/const';

// eslint-disable no-unused-expressions
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
export function LicenseTable({
  data,
  toggleRowSelection,
  selectedRows,
  handleSelectAll,
  showModal,
}) {
  const [selectAll, setSelectAll] = useState(false);
  const toggleSelectAll = () => {
    setSelectAll(!selectAll);
    handleSelectAll();
  };
  const tableColumns = [
    {
      Header: ({ row }) => (
        <Checkbox onChange={() => toggleSelectAll()} checked={selectAll} />
      ),
      accessor: 'id',
      sortable: false,
      filterable: false,
      Cell: ({ row }) => {
        return (
          <Checkbox
            checked={selectedRows.includes(row.id)}
            onChange={() => toggleRowSelection(row)}
          />
        );
      },
    },
    {
      Header: 'Financial Institution',
      accessor: 'fi',
      filterMethod: startsWithCaseInsensitive,

      Cell: row => (
        <a className="edit-link" onClick={() => showModal(row.original)}>
          {row.value}
        </a>
      ),
    },

    {
      Header: 'Account',
      accessor: 'account',

      filterMethod: startsWithCaseInsensitive,
      Cell: row => <div className="has-text-centered">{row.value}</div>,
    },
    {
      Header: 'Location',
      accessor: 'location',
      filterMethod: startsWithCaseInsensitive,
      Cell: row => <div className="has-text-centered">{row.value}</div>,
    },
    {
      Header: 'License Number',
      accessor: 'licenseNumber',
      filterMethod: startsWithCaseInsensitive,
      Cell: row => <div className="has-text-centered">{row.value}</div>,
    },
    {
      Header: 'License Expiration',
      accessor: 'expiration',
      filterable: false,
      Cell: row => (
        <div className="has-text-centered">
          {row.value ? dayjs(row.value).format(DATE_SMONTH_DAY_SYEAR) : null}
        </div>
      ),
    },
    {
      Header: 'State',
      accessor: 'state',
      filterMethod: startsWithCaseInsensitive,
      Cell: row => <div className="has-text-centered">{row.value}</div>,
    },
    {
      Header: 'BG Date',
      accessor: 'bgDate',
      filterable: false,
      Cell: row => (
        <div className="has-text-centered">
          {row.value ? dayjs(row.value).format(DATE_SMONTH_DAY_SYEAR) : null}
        </div>
      ),
    },
    {
      Header: 'BG Result',
      accessor: 'bgResult',
      filterMethod: startsWithCaseInsensitive,
      Cell: row => <div className="has-text-centered">{row.value}</div>,
    },
    {
      Header: 'License Link',
      accessor: 'licenseLink',
      filterable: false,
      sortable: false,
      Cell: row => (
        <div className="has-text-centered">
          {row.value ? (
            <a href={row.value} target="_blank" rel="noopener noreferrer">
              Link
            </a>
          ) : null}
        </div>
      ),
    },
    {
      Header: 'Consent',
      accessor: 'consentLink',
      filterable: false,
      sortable: false,
      Cell: row => (
        <div className="has-text-centered">
          {row.value ? (
            <a href={row.value} target="_blank" rel="noopener noreferrer">
              Link
            </a>
          ) : null}
        </div>
      ),
    },
  ];

  return (
    <>
      <UiTable
        className="transactions-table -striped -highlight"
        columns={tableColumns}
        data={data}
        useTablePagination
        resolveData={data =>
          data.map(transaction => ({
            ...transaction,
          }))
        }
        getTheadThProps={(_state, _rowInfo, column) => {
          if (column.id === 'amount') {
            return { className: 'has-text-right' };
          }
          if (column.id !== 'date') {
            return { className: 'has-text-left' };
          }
          return { className: '' };
        }}
        title="Transaction"
        filterable
        hideButton
        hideNext
        hidePrev
      />
    </>
  );
}

LicenseTable.propTypes = {
  data: propTypes.arrayOf(propTypes.object).isRequired,
};
